import React, { ComponentType, FunctionComponent } from 'react';

import { DataTableCellProps } from 'components/dataTable/dataTable.types';
import { DataTableCell } from 'components/dataTable/dataTableCell';

import { COLUMN_IDS } from '../../apiKeys.keys';
import { ActionsTableCell } from './actionsCell';
import { DateCell } from './dateCell';
import { SecretKeyCell } from './secretKeyCell';

const cellComponentMap: { [key: string]: ComponentType<DataTableCellProps> } = {
  [COLUMN_IDS.SECRET_KEY]: SecretKeyCell,
  [COLUMN_IDS.CREATED_AT]: DateCell,
  [COLUMN_IDS.LAST_USED_AT]: DateCell,
  [COLUMN_IDS.ACTIONS]: ActionsTableCell,
  default: DataTableCell,
};

interface CustomCellComponentFactoryProps {
  onEdit: (uuid: string) => void;
  onDelete: (uuid: string) => void;
  canManageActions: boolean;
}

export const customCellComponentFactory =
  ({ onEdit, onDelete, canManageActions }: CustomCellComponentFactoryProps): FunctionComponent<DataTableCellProps> =>
  (props: DataTableCellProps) => {
    const { column } = props;
    const SelectedComponent = cellComponentMap[column.id] || cellComponentMap.default;

    return <SelectedComponent {...props} passedProps={{ onEdit, onDelete, canManageActions }} />;
  };
